import { createSelector } from 'reselect'
import { find } from 'lodash'

const getAllLists = (state) => state.data
const getProps = (_state, props) => props

const selectUserRole = (state) => state.global.user.role
const selectAbilityInstance = (state) => state?.global?.ability
const selectRoles = (_, props) => props.roles
const selectAbilities = (_, props) => props.abilities

export const populateWithListData = createSelector(
  [getAllLists, getProps],
  (lists, { populate, data }) => {
    if (!data) return null
    return data.map((row) => {
      populate.forEach(({ key, list }) => {
        let id = row[key]
        if (lists[list] && id) {
          row[key] = find(lists[list], { id })
        }
      })
      return row
    })
  }
)

export const checkRoleAccess = createSelector(
  [selectUserRole, selectAbilityInstance, selectRoles, selectAbilities],
  (userRole, abilityInstance, roles, abilities) => {
    if (!userRole) return false

    const hasRoles = Array.isArray(roles) ? roles.length > 0 : !!roles
    const hasAbilities = abilities?.length > 0

    if (!hasRoles && !hasAbilities) {
      return true
    }

    const roleAccess = Array.isArray(roles)
      ? roles.includes(userRole)
      : userRole === roles

    if (roleAccess) {
      return true
    }

    if (hasAbilities) {
      return abilities.every(({ i: action, this: subject }) =>
        abilityInstance.can(action, subject)
      )
    }

    return false
  }
)

export const checkAbilityAccess = createSelector(
  [selectAbilityInstance, selectAbilities],
  (abilityInstance, abilities) => {
    if (!abilities?.length) return true
    return abilities.every(({ i: action, this: subject }) =>
      abilityInstance.can(action, subject)
    )
  }
)
